import {useCallback, useEffect, useState} from 'react';
import type {AstView} from 'rendition-core';
import {useHistory} from 'react-router-dom';

import {cloneDocument, compileDocument, getZippedAssets} from 'Common/api';

interface Args {
    view: AstView | null;
    setView: (view: AstView) => void;
    id: string;
    loading: boolean;
    setLoading: React.Dispatch<React.SetStateAction<boolean>>;
    save: () => void;
}

const useDownloadAssets = (view: AstView | null) => {
    const [fetchingZip, setFetchingZip] = useState(false);
    const [zipUrl, setZipUrl] = useState(view?.meta.assetUrlZip);

    useEffect(() => {
        if (fetchingZip === false && view && view?.meta.assetUrlZip === undefined) {
            setFetchingZip(true);
            const fetchZipUrl = async () => {
                const result = await getZippedAssets(view);
                setZipUrl(result.data.view.meta.assetUrlZip);
                view.meta.assetUrlZip = zipUrl;
            };
            fetchZipUrl();
        }

        if (zipUrl !== '' && view && !view?.meta.assetUrlZip) {
            view.meta.assetUrlZip = zipUrl;
        }
    }, [view, fetchingZip, zipUrl]);
};

export const useDocumentActions = ({view, setView, id, loading, setLoading, save}: Args) => {
    const history = useHistory();
    useDownloadAssets(view);

    const onGetCode = useCallback(async () => {
        await save();
        await compileDocument(id);
        setLoading(true);
        history.push(`/preview/${id}`);
    }, [history, id, save, setLoading]);

    const cloneDoc = useCallback(async () => {
        const res = await cloneDocument(id);
        history.push(`/builder/${res.data.id}`);
    }, [history, id]);

    return {onGetCode, cloneDoc};
};
